import { Component } from '@angular/core';
import { PanAppState, PlatformService } from '@panamax/app-state';

@Component({
  selector: 'app-product-usage',
  templateUrl: './product-usage.page.html',
  styleUrls: ['./product-usage.page.scss'],
})
export class ProductUsagePageComponent {
  isMobile = false;
  constructor(
    public platformService: PlatformService,
    readonly panAppState: PanAppState,
  ) {}

  ionViewWillEnter() {
    this.panAppState.setPageTitle('Product Usage');
    this.isMobile =
      this.platformService?.platformType ===
      this.platformService?.platformEnum?.mobile;
  }
}
